import React, {Component} from 'react'
// tabella contrassegni
import BackOfficeFiltersComponent from '../components/BackOfficeFiltersComponent'

import UserFormatter from '../components/grid-formatters/UserFormatter'
import ReactTable from 'react-table'
import MarkTypeFilter from '../components/ReactTable/Filters/MarkTypeFilter'

export default class BackOfficeMarkScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserDetailModal: false,
      selectedUser: null,
      columns: [
        {
          Header: 'Nome',
          accessor: 'User.firstName',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            return (<div>{row.value}</div>)
          }
        },
        {
          Header: 'Cognome',
          accessor: 'User.lastName',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            return (<div>{row.value}</div>)
          }
        },
        {
          Header: 'Tipo di Contrassegno',
          accessor: 'MarkType.name',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            return (<div>{row.value}</div>)
          },
          Filter: ({ filter, onChange }) => <MarkTypeFilter filter={filter} onChange={onChange} />
        },
        {
          Header: 'ID',
          accessor: 'id',
          filterable: true,
          sortable: false,
          Cell: (row) => {
            return (<div>{row.value}</div>)
          }
        },
        {
          Header: 'Veicoli',
          accessor: 'Vehicles',
          filterable: true,
          sortable: false,
          minWidth: 200,
          Cell: (row) => {
            return (<div>{row.value.map((item, index) => {
              let string = ''
              string = string + item.plate_number
              if (index < row.value.length - 1) {
                string = string + ', '
              }
              return string
            })}</div>)
          }
        }
      ]
    }

    this.getTotalPages = this.getTotalPages.bind(this)
    this.onFetchData = this.onFetchData.bind(this)
  }

  onFetchData (state, instance) {
    let filterObj = {}
    for (let i in state.filtered) {
      let f = state.filtered[i]

      if (f.id === 'id') {
        filterObj['id'] = f.value
      }

      if (f.id === 'Vehicles') {
        filterObj['plate_number'] = f.value
      }

      if (f.id === 'User.firstName') {
        filterObj['firstName'] = f.value
      }

      if (f.id === 'User.lastName') {
        filterObj['lastName'] = f.value
      }

      if (f.id === 'MarkType.name') {
        filterObj['markTypeId'] = f.value
      }
    }

    let sortObj = {}
    for (let i in state.sorted) {
      let s = state.sorted[i]
      sortObj[s.id] = s.desc ? 'desc' : 'asc'
    }

    this.props.fetchMarks(filterObj, state.pageSize, state.page)
  }

  getTotalPages () {
    const {pagination} = this.props

    if (!pagination) {
      return 0
    }

    if (pagination.total === 0) {
      return 0
    }

    return Math.ceil(pagination.total / pagination.limit)
  }

  render () {
    const {columns} = this.state
    return (<div>
      <ReactTable
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (!rowInfo) {
                return
              }
              this.props.onRowClick(rowInfo.index, rowInfo.original)
            }}
        }}
        manual
        filterable
        loading={this.props.loading}
        noDataText={'Nessun Contrassegno Presente'}
        onFetchData={this.onFetchData}
        pages={this.getTotalPages()}
        className="-highlight"
        data={this.props.marks ? this.props.marks : []}
        style={{maxHeight: '500px'}}
        defaultPageSize={100}
        nextText="Avanti"
        previousText="Indietro"
        loadingText="Caricamento in corso..."
        rowsText="elementi"
        ofText="di"
        pageText="Pagina"
        columns={columns} />
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/screens/BackOfficeMarkScreen.js